export default "__VITE_ASSET__mFmWLQB0__"